import { OnInit, OnChanges, Input, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { StripeService, USStripeService } from '../stripe.service';

@Component({
	selector: 'azc-stripe-payment-request',
	template: `<div #stripePaymentRequest></div>`,
	styles: ['']
})
export class AzcStripePaymentRequestComponent implements OnInit, OnChanges {
	@ViewChild('stripePaymentRequest') private _stripeElement: ElementRef;
	@Output() private onToken = new EventEmitter<string>();
	@Input() private currencyCode: string;
	@Input() public amount: number;
	private stripePaymentRequest: any;
	public isEnabled: boolean;
	private get stripeAmount() {
		// todo: We only support NZD/AUD/USD/CAD which are all decimal. If we support YEN, etc we need to not multiple price k thnx.
		return this.amount * 100;
	}

	constructor(private _ss: StripeService, private _uss: USStripeService) { }

	async ngOnInit() {
		let stripe = await this._ss.stripe;
		let country = 'AU';

		if (this.currencyCode && this.currencyCode.toLowerCase() === 'usd') {
			console.log('use US stripe');
			stripe = await this._uss.stripe;
			country = 'US';
		}

		this.stripePaymentRequest = stripe.paymentRequest({
			country: country,
			currency: this.currencyCode.toLowerCase(),
			total: {
				label: 'AmazingCo Payment',
				amount: this.stripeAmount,
			},
		});

		const paymentRequestButton = stripe.elements().create('paymentRequestButton', { paymentRequest: this.stripePaymentRequest });

		this.isEnabled = await this.stripePaymentRequest.canMakePayment();

		if (this.isEnabled) {
			paymentRequestButton.mount(this._stripeElement.nativeElement);

			this.stripePaymentRequest.on('token', event => {
				this.onToken.emit(event.token.id);
			});
		}
	}

	ngOnChanges() {
		if (this.stripePaymentRequest) {
			this.stripePaymentRequest.update({
				currency: this.currencyCode.toLowerCase(),
				total: {
					label: 'AmazingCo Payment',
					amount: this.stripeAmount,
				}
			});
		}
	}
}

